import { Tag } from 'antd';
import startCase from 'lodash/startCase';
import React from 'react';

interface ResultSheetStatusProps {
  status: string;
}

const getResultSheetStatusColor = (status: string) => {
  if (status === 'pending') {
    return 'gold';
  }
  if (status === 'notApproved') {
    return 'error';
  }
  if (status === 'approved') {
    return 'success';
  }
  return 'default';
};

export const ResultSheetStatusTag = ({ status }: ResultSheetStatusProps) => {
  return <Tag color={getResultSheetStatusColor(status)}>{startCase(status)}</Tag>;
};
